export const helpCenterKeys = {
  helpCenter: ['helpCenter'] as const,
  getHelpCenterCategories: (params: HelpCenterCategoryParams) => [
    ...helpCenterKeys.helpCenter,
    'getHelpCenterCategories',
    params
  ],
  getHelpCenterArticles: (params: HelpCenterArticlesParams) => [
    ...helpCenterKeys.helpCenter,
    'getHelpCenterArticles',
    params
  ],
  getHelpCenterArticleDetail: (slug: string) => [
    ...helpCenterKeys.helpCenter,
    'getHelpCenterArticleDetail',
    slug
  ]
}
